// The tabs that arrive in the next phases: named honestly, in the design's
// own empty-state voice, with what each will hold.
import { S } from '../lib/strings';
import { Ic, type IconName } from '../components/Icon';
import type { Tab } from '../components/Shell';

const ICON: Record<string, IconName> = { live: 'map', hh: 'house', dev: 'chip', mk: 'cyl', team: 'users', fin: 'wallet' };

export function Soon({ tab }: { tab: Exclude<Tab, 'ov' | 'ord' | 'live' | 'hh' | 'dev' | 'fin' | 'team' | 'mk'> }) {
  return (
    <section className="view on" aria-label={S.tabs[tab]}>
      <div className="ph"><div><h1>{S.tabs[tab]}</h1><p>{S.soonTab.sub}</p></div></div>
      <div className="card soon">
        <span className="soon-ic"><Ic n={ICON[tab]} /></span>
        <b>{S.soonTab.phase[tab]}</b>
      </div>
    </section>
  );
}
